import { Topic, topics } from "@/data/topicsData";

export const useTopicData = () => {
  return {
    topics,
    isLoading: false,
    error: null as string | null
  };
};
